export default __webpack_public_path__ + "static/BoschSans-Bold-a8b71956eea0c44d43e46a672646950d.woff";